module.exports = __webpack_public_path__ + "img/ground-sea-night.ec4fb12e.png";